export type IconProps = {
  nome: string;
  tamanho?: number;
  cor?: string;
};

/**
 * Ícone Material Symbols Rounded. `tamanho` controla o font-size (default 18px
 * herdado do global). `cor` aceita qualquer cor CSS (inclusive var(--token)).
 */
export default function Icon({ nome, tamanho, cor }: IconProps) {
  return (
    <span
      className="material-symbols-rounded"
      style={{ fontSize: tamanho, color: cor }}
      aria-hidden="true"
    >
      {nome}
    </span>
  );
}
